<template>
  <div class="main-desktop-tabs__parent">
    <div class="main-desktop-tabs__parent-icon">
      <component :is="parent.icon" v-if="parent.icon" aria-hidden="true" />
    </div>
    <div class="main-desktop-tabs__parent-name">
      {{ parent.label }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { NavigationItem } from '@types'

type Props = {
  parent: NavigationItem
}

defineProps<Props>()
</script>

<style scoped>
.main-desktop-tabs {
  &__parent {
    @apply relative;
    @apply flex items-center;
    @apply pr-3 mr-1.5;
    @apply text-sm;
    @apply text-light-text;

    @apply after:content-[''];
    @apply after:h-5;
    @apply after:absolute after:right-0;
    @apply after:border-r after:border-common-border;
  }

  &__parent-icon {
    @apply size-6;
    @apply flex items-center justify-center;
    @apply shrink-0;

    svg {
      @apply size-4;
    }
  }
}
</style>
